import { createSlice } from '@reduxjs/toolkit';
import { CommunityGetListByPost } from '../api/CommunityAPI';

// 초기 상태
const initialState = {
  titleList: [],
};

// Slice 생성
const communityListSlice = createSlice({
  name: 'communityList',
  initialState,
  reducers: {
    setCommunityList: (state, action) => {
      state.titleList = action.payload;
    },
    resetCommunityList: (state) => {
      state.titleList = [];
    },
  },
});

export const { setCommunityList, resetCommunityList } = communityListSlice.actions;

export const fetchCommunityList = () => async (dispatch) => {
  try {
    const response = await CommunityGetListByPost();

    dispatch(setCommunityList(response.data));
  } catch (error) {
    console.error('Failed to fetch community list:', error);
  }
};

// export const CommunityList = () => async (dispatch) => {
//     dispatch(setCommunityList(response.data));

// }

export default communityListSlice.reducer;
